<eight-cap-card [title]="(data && data.type) ? capitalize(data.type) : ''">
    <form
        class="p-24"
        fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto"
        name="form" [formGroup]="form"
    >
        <!-- Fingerprint / Id -->
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <div class="h2 mb-16" fxFlex="0 1 100%"><strong>Value:</strong></div>
            <div class="h2 mb-16" fxFlex="0 1 100%">{{ (data && data.value) ? data.value : '' }}</div>
        </div>

        <!-- Watchlist id -->
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <div class="h2 mb-16" fxFlex="0 1 100%"><strong>Watchlist:</strong></div>
            <mat-form-field appearance="outline" fxFlex="0 1 100%" *ngIf="!isLoading">
                <mat-label>Watchlist</mat-label>
                <mat-select formControlName="id">
                    <mat-option
                        *ngFor="let watchList of watchLists"
                        [value]="watchList.id">
                        {{ watchList.watchlist }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            
            <mat-spinner *ngIf="isLoading" class="mb-16" color="primary" [diameter]="30">
            </mat-spinner>
        </div>

        <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">
                <mat-icon>save</mat-icon>
                <span class="hide-text">Save</span>
            </button>
        </div>
    </form>
</eight-cap-card>
